export const getAuthorInitials = (authorName: string) => {
  return (
    `${authorName.split(" ")[0]?.[0] || ""}` +
    `${authorName.split(" ")[1]?.[0] || ""}`
  ).toUpperCase();
};
